import React from 'react';
import { NavLink } from 'react-router-dom';
// import Header4 from './../Common/Header4';
// import Footer from './../Common/Footer';
// import Banner from './../Elements/Banner';

// var bnrimg = require('./../../images/deals-bg.jpg');

// const filters = [
//     { label: "Construction", filter: ".cat-1" },
//     { label: "Renovation", filter: ".cat-2" },
//     { label: "Outdoor", filter: ".cat-3" },
//     { label: "Interiors", filter: ".cat-4" },
//     { label: "Consulting", filter: ".cat-5" },

// ];

const projects = [
    {
        thumb: require('./../../images/choose-us.jpg'),
        image: require('./../../images/projects/portrait/pic4.jpg'),
        title: 'Life style building',
        description: `We are so busy watching out for what's just ahead of us that we don't take the time to enjoy where we are.`,
        filter: 'cat-1'
    }
]

class WhyChoose extends React.Component {

    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };

    render() {
        return (
            <>
                <div className="section-full p-tb80 inner-page-padding">
                    <div className="container">
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Why</span>Choose Us</h2>
                                </div>
                            </div>
                        </div>
                        {/* <div className="portfolio-wrap mfp-gallery work-grid row clearfix"> */}
                        {projects.map((item, index) => (
                            <div key={index} className={`${item.filter} masonry-item col-md-12 col-sm-6 m-b30`}>
                                <div className="image-effect-two hover-shadow">
                                    <img
                                        src={item.thumb}
                                        alt=""
                                        style={{ height: "100%", width: "100%", maxHeight: "450px" }}
                                    />
                                    <div className="figcaption" style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "start",
                                        flexDirection: "column",
                                    }}>
                                        <div>
                                            <h4 className="mt-tilte">Why ENN Living Interiors?</h4>
                                            <ul style={{ paddingLeft: "20px", marginBottom: "25px" }}>
                                                <li>Nearly a decade of experience in bespoke interiors</li>
                                                <li>Trusted by homeowners across Uxbridge and surrounding regions</li>
                                                <li>Long-standing team of skilled professionals</li>
                                                <li>Flexible, budget-friendly solutions without compromising on quality</li>
                                                <li>Access to real client references and completed projects</li>
                                                <li>Gallery and social proof available across website and social media</li>
                                            </ul>
                                            <NavLink to="/about" className="read-more site-button btn-effect">
                                                Read More
                                            </NavLink>
                                            <a className="mfp-link" href={item.image}>
                                                <i className="fa fa-arrows-alt" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}


                        {/* </div> */}
                    </div>
                </div>
            </>
        );
    };
};

export default WhyChoose;